import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8f2969a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-icones-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Novo", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ss-tela-conteudo" }
const _hoisted_9 = { class: "ss-card ss-card-space" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_13 = { class: "ant-row ss-alinhar-texto-esquerda" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_16 = { class: "ant-row ss-acoes-massa" }
const _hoisted_17 = {
  key: 0,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Baixar", -1))
const _hoisted_19 = {
  key: 1,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Alterar", -1))
const _hoisted_21 = {
  key: 2,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Antecipar", -1))
const _hoisted_23 = {
  key: 3,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Imprimir", -1))
const _hoisted_25 = {
  key: 4,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Excel", -1))
const _hoisted_27 = {
  key: 5,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Excluir", -1))
const _hoisted_29 = {
  key: 6,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Gerar Boletos", -1))
const _hoisted_31 = {
  key: 7,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"4px"} }, "Imprimir Boletos", -1))
const _hoisted_33 = {
  key: 8,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Gerar Remessa", -1))
const _hoisted_35 = {
  key: 9,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"1px"} }, "Enviar Cobrança", -1))
const _hoisted_37 = {
  key: 10,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Negativar", -1))
const _hoisted_39 = {
  key: 11,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Protestar", -1))
const _hoisted_41 = {
  key: 12,
  class: "ant-col ant-col-xs-8 ant-col-xl-8"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "Emitir NFS-e", -1))
const _hoisted_43 = {
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"55%"}
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 5,
  class: "acoes-item"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { key: 6 }
const _hoisted_54 = { key: 7 }
const _hoisted_55 = { key: 8 }
const _hoisted_56 = { key: 9 }
const _hoisted_57 = {
  key: 10,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1))
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Valor :", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Competência:", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Baixa:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1))
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "acoes-item ss-alinhar-centro" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  class: "ant-row",
  style: {"padding":"10px"}
}
const _hoisted_73 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_74 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_75 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_76 = { class: "ant-input-suffix" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_78 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}
const _hoisted_79 = {
  key: 0,
  style: {"height":"120px"}
}
const _hoisted_80 = { class: "ss-acoes-massa" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exportar", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Word", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Excel", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CSV", -1))
const _hoisted_85 = { class: "ant-row" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gerar Boleto(s)")
], -1))
const _hoisted_87 = { class: "ant-row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Imprimir Boleto(s)")
], -1))
const _hoisted_89 = { class: "ant-row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gerar Remessa")
], -1))
const _hoisted_91 = { class: "ant-row" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Enviar Cobrança")
], -1))
const _hoisted_93 = { class: "ant-row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Negativar Títulos")
], -1))
const _hoisted_95 = { class: "ant-row" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Protestar Títulos")
], -1))
const _hoisted_97 = { class: "ant-row" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Emitir NFS-e")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_preferencias_coluna = _resolveComponent("preferencias-coluna")!
  const _component_titulo_financeiro_totalizadores = _resolveComponent("titulo-financeiro-totalizadores")!
  const _component_calendario_eventos = _resolveComponent("calendario-eventos")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_card = _resolveComponent("card")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_conta_receber_modal = _resolveComponent("conta-receber-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_importacao_registros_excel_modal = _resolveComponent("importacao-registros-excel-modal")!
  const _component_emissao_n_f_se_titulo_financeiro_modal = _resolveComponent("emissao-n-f-se-titulo-financeiro-modal")!
  const _component_alteracao_financeiro_massa_modal = _resolveComponent("alteracao-financeiro-massa-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: _ctx.telaBase.identificadorRecurso,
            tituloRecurso: _ctx.telaBase.titulo,
            exibirAtalhosTela: true,
            exibirHistoricoTela: true,
            empresasSelecionadas: [_ctx.state.empresaSelecionada]
          }, {
            ExtrasTitulo: _withCtx(() => [
              (!_ctx.storeSistema.state.layoutMobile)
                ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 0 }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.apresentarPersonalizarColuna && _ctx.apresentarPersonalizarColuna(...args)))
                              }, "Personalizar Colunas")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_4, [
                        _createVNode(_component_icone, { nome: "personalizacoes" })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.storeSistema.state.layoutMobile)
                ? (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                    overlay: _withCtx(() => [
                      _createVNode(_component_a_menu, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvarPreferenciasFiltros(_ctx.telaBase.empresasSelecionadas,_ctx.tituloFinanceiroBase.buscaAvancada.filtrosAdicionados)))
                              }, "Salvar filtros")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvarPreferenciasOrdenacao(_ctx.telaBase.empresasSelecionadas,_ctx.telaBase.ordenacaoSelecionada)))
                              }, "Salvar ordenação")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvarPreferenciasGrade(_ctx.telaBase.empresasSelecionadas,_ctx.gradeBase.colunas)))
                              }, "Salvar colunas")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_menu_item, null, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redefinirPersonalizacaoColunas(_ctx.telaBase.empresasSelecionadas, _ctx.telaBase.identificadorRecurso)))
                              }, "Redefinir colunas")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("a", null, [
                        _createVNode(_component_icone, {
                          class: "ss-icones-acoes",
                          nome: "filtro"
                        })
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", {
                class: "ss-principais-acoes",
                style: _normalizeStyle(_ctx.storeSistema.state.layoutMobile ? 'margin-left: auto; margin-right: auto;' : '')
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Imprimir",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Word",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                  }, [
                    _createVNode(_component_icone, { nome: "word" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Excel",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                  }, [
                    _createVNode(_component_icone, { nome: "excel" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar CSV",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                  }, [
                    _createVNode(_component_icone, { nome: "download-arquivo" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Importar pelo Excel",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.abrirImportacaoExcel && _ctx.abrirImportacaoExcel(...args)))
                  }, [
                    _createVNode(_component_icone, { nome: "download" })
                  ]),
                  (_ctx.telaBase.permissaoDados.incluir)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "ant-btn ant-btn-primary ss-btn-tela",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.incluir()))
                      }, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ]),
            _: 1
          }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.empresaSelecionada,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.empresaSelecionada) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createVNode(_component_preferencias_coluna, {
                colunas: _ctx.gradeBase.colunas,
                "onUpdate:colunas": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.gradeBase.colunas) = $event)),
                visivel: _ctx.state.exibirPersonalizarColunas,
                "onUpdate:visivel": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.exibirPersonalizarColunas) = $event)),
                recurso: _ctx.telaBase.identificadorRecurso
              }, null, 8, ["colunas", "visivel", "recurso"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_titulo_financeiro_totalizadores, {
                    ref: "refTotalizadores",
                    empresa: _ctx.state.empresaSelecionada,
                    tipo: _ctx.ETipoTituloFinanceiro.Receber,
                    onFiltrarTitulos: _cache[14] || (_cache[14] = ($event: any) => (_ctx.filtrarTitulosPelosTotalizadores($event)))
                  }, null, 8, ["empresa", "tipo"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_card, {
                    style: {"margin-left":"5px"},
                    titulo: " "
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_spin, {
                        spinning: _ctx.state.carregandoCalendario
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_calendario_eventos, {
                            eventos: _ctx.tituloFinanceiroBase.eventos,
                            onClickDia: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clickDia($event))),
                            dataCalendario: _ctx.tituloFinanceiroBase.dataCalendario,
                            "onUpdate:dataCalendario": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.tituloFinanceiroBase.dataCalendario) = $event)),
                            onBuscarEventos: _cache[17] || (_cache[17] = ($event: any) => (_ctx.preencherEventos()))
                          }, null, 8, ["eventos", "dataCalendario"])
                        ]),
                        _: 1
                      }, 8, ["spinning"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            (_ctx.storeSistema.state.layoutMobile && (_ctx.gradeBase.codigosSelecionados.length > 0))
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  style: {"width":"100%"},
                  titulo: "Ações em massa"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
                    _createElementVNode("span", null, "    R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.totalSelecionado)), 1),
                    _createElementVNode("div", _hoisted_16, [
                      ((_ctx.verificarAutorizacao('AUT_BAIXAS_CONTAS_RECEBER') && _ctx.tituloFinanceiroBase.titulosBaixar.length > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("a", {
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.baixarTitulos())),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "correto",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_18
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.tituloFinanceiroBase.titulosAlterar.length > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createElementVNode("a", {
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.alterarTitulos())),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "editar",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_20
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.tituloFinanceiroBase.titulosBaixar.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("a", {
                              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.anteciparTitulos())),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "correto",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_22
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.telaBase.permissaoDados.imprimir)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("a", {
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF))),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "imprimir",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_24
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.telaBase.permissaoDados.imprimir)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("a", {
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel))),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "excel",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_26
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.telaBase.permissaoDados.excluir && _ctx.tituloFinanceiroBase.titulosExcluir.length > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("a", {
                              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.confirmarExclusaoEmMassa())),
                              style: {"text-align":"center"}
                            }, [
                              _createVNode(_component_icone, {
                                nome: "excluir",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_28
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosSelecionados > 0 || _ctx.state.qtdBoletosGeradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("a", {
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.confirmarGerarBoletos(true)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "codigo-barras",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_30
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("a", {
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.confirmarGerarBoletos(false)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "imprimir",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_32
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            _createElementVNode("a", {
                              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.confirmarGerarRemessa && _ctx.confirmarGerarRemessa(...args)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "compactar",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_34
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("a", {
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.confirmarEnviarEmailBoletos(true)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "email",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_36
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosRegistradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createElementVNode("a", {
                              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.confirmarNegativcao(true)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "documento-martelo",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_38
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.qtdBoletosRegistradosSelecionados > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("a", {
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.confirmarNegativcao(false)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "documento-martelo",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_40
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.state.qtdGerarNfse > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("a", {
                              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.apresentarEmissaoNFSe && _ctx.apresentarEmissaoNFSe(...args)))
                            }, [
                              _createVNode(_component_icone, {
                                nome: "emitir-nfse",
                                class: "ss-icone-acao-massa-mobile"
                              }),
                              _hoisted_42
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_busca_geral, {
                empresas: [_ctx.state.empresaSelecionada],
                ordenacao: _ctx.telaBase.ordenacaoSelecionada,
                "onUpdate:ordenacao": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                buscaRapida: _ctx.tituloFinanceiroBase.buscaRapida,
                "onUpdate:buscaRapida": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.tituloFinanceiroBase.buscaRapida) = $event)),
                buscaAvancada: _ctx.tituloFinanceiroBase.buscaAvancada,
                "onUpdate:buscaAvancada": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.tituloFinanceiroBase.buscaAvancada) = $event)),
                onBuscarDados: _cache[34] || (_cache[34] = ($event: any) => (_ctx.buscarTitulos(true))),
                placeholder: 'Busca rápida: Digite o número de identificação, data, valor ou alguma informação da pessoa para localizarmos o que você procura...'
              }, null, 8, ["empresas", "ordenacao", "buscaRapida", "buscaAvancada", "placeholder"]),
              _createVNode(_component_card, {
                titulo: " ",
                style: _normalizeStyle(_ctx.gradeBase.codigosSelecionados.length > 0 ? 'padding-bottom: 108px;' : '')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.layoutMobile? _ctx.gradeBase.colunasMobile.filter(item => item.visible) :  _ctx.gradeBase.colunas.filter(item => item.visible),
                    "data-source": _ctx.tituloFinanceiroBase.titulos,
                    rowKey: "id",
                    pagination: false,
                    loading: _ctx.telaBase.carregando,
                    scroll: _ctx.gradeBase.layoutMobile? null: { x: (_ctx.gradeBase.windowWidth +500), y: _ctx.window.innerHeight - 300 },
                    "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados, onChange: _ctx.mudarSelecao },
                    size: "small"
                  }, {
                    headerCell: _withCtx(({ column }) => [
                      _createVNode(_component_coluna_grade, {
                        column: column,
                        ordenacaoSelecionada: _ctx.telaBase.ordenacaoSelecionada,
                        "onUpdate:ordenacaoSelecionada": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.telaBase.ordenacaoSelecionada) = $event)),
                        filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                        "onUpdate:filtrosCabecalho": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                        onBuscarDados: _cache[37] || (_cache[37] = ($event: any) => (_ctx.buscarTitulos(true)))
                      }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho"])
                    ]),
                    bodyCell: _withCtx(({ column, record, text }) => [
                      (column.key === 'TipoDocumentoFinanceiro')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.Emitido)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 0,
                                  title: "Boleto emitido",
                                  class: "ss-tag-status boleto-emitido"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.Registrado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 1,
                                  title: "Boleto registrado",
                                  class: "ss-tag-status boleto-registrado"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.Negativado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 2,
                                  title: "Boleto negativado",
                                  class: "ss-tag-status boleto-negativado"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.Protestado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 3,
                                  title: "Boleto protestado",
                                  class: "ss-tag-status boleto-protestado"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.Baixado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 4,
                                  title: "Boleto baixado",
                                  class: "ss-tag-status boleto-baixado"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.DescontoRequisitado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 5,
                                  title: "Boleto com descontado requisitado",
                                  class: "ss-tag-status boleto-descontado-requisitado"
                                }))
                              : _createCommentVNode("", true),
                            (record.tipoEmissaoBoleto === _ctx.ETipoEmissaoBoleto.Propria && record.situacaoBoleto === _ctx.ESituacaoBoleto.DescontoEfetivado)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 6,
                                  title: "Boleto descontado",
                                  class: "ss-tag-status boleto-descontado-efetivado"
                                }))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(record.descricaoTipoDocumentoFinanceiro), 1)
                          ]))
                        : (column.key === 'Valor')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obtemValorTitulo(record))), 1))
                          : (column.key === 'Observacoes')
                            ? (_openBlock(), _createBlock(_component_a_popover, {
                                key: 2,
                                title: 'Observações do título: ' + record.numeroTitulo
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", {
                                    style: {"white-space":"pre-wrap!important","line-height":"12px"},
                                    innerHTML: record.observacoes
                                  }, null, 8, _hoisted_46)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.UtilitarioGeral.removerTagsHtml(record.observacoes)
                                  }, null, 8, _hoisted_47)
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            : (column.customRenderRow === _ctx.ECustomRenderRow.LinkAcao)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 3,
                                  onClick: ($event: any) => (_ctx.editar(record.codigo))
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(text), 1)
                                ], 8, _hoisted_48))
                              : (column.key === 'Status')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    ((record.pessoaRepasse > 0 && (record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente)))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createVNode(_component_a_tag, {
                                            title: "Repassado",
                                            class: "ss-tag-status titulo-baixado"
                                          }),
                                          _createTextVNode("Repassado ")
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_component_a_tag, {
                                            title: text,
                                            class: _normalizeClass('ss-tag-status titulo-' + _ctx.obterClasseStatus(text))
                                          }, null, 8, ["title", "class"]),
                                          _createTextVNode(_toDisplayString(text), 1)
                                        ], 64))
                                  ], 64))
                                : (column.customRenderRow === _ctx.ECustomRenderRow.IconeAcoes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                      _createElementVNode("a", {
                                        class: "visualizar",
                                        onClick: ($event: any) => (_ctx.editar(record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "visualizar" })
                                      ], 8, _hoisted_50),
                                      _createElementVNode("a", {
                                        class: "imprimir",
                                        onClick: ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF, record.codigo))
                                      }, [
                                        _createVNode(_component_icone, { nome: "imprimir" })
                                      ], 8, _hoisted_51),
                                      _createElementVNode("a", {
                                        onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                                        class: "excluir"
                                      }, [
                                        _createVNode(_component_icone, { nome: "excluir" })
                                      ], 8, _hoisted_52)
                                    ]))
                                  : (column.customRenderRow === _ctx.ECustomRenderRow.MascararCPFCNPJ)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(text)), 1))
                                    : (column.customRenderRow === _ctx.ECustomRenderRow.MascararTelefoneCelular)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_ctx.UtilitarioMascara.mascararTelefoneFixoOuCelular(text)), 1))
                                      : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text)), 1))
                                          : (column.key === 'TituloFinanceiro')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                _createElementVNode("span", null, [
                                                  _hoisted_58,
                                                  _createTextVNode(" " + _toDisplayString(record.siglaTipoDocumentoFinanceiro + ' - ' + record.descricaoTipoDocumentoFinanceiro), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_59,
                                                  _createTextVNode(),
                                                  _createElementVNode("a", {
                                                    onClick: ($event: any) => (_ctx.editar(record.codigo))
                                                  }, _toDisplayString(record.numeroTitulo), 9, _hoisted_60)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_61,
                                                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.obtemValorTitulo(record),2)), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_62,
                                                  _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_63,
                                                  _createTextVNode(" " + _toDisplayString(record.dataVencimentoFormatada), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_64,
                                                  _createTextVNode(" " + _toDisplayString(record.dataCompetenciaFormatada), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_65,
                                                  _createTextVNode(" " + _toDisplayString(record.dataBaixaFormatada), 1)
                                                ]),
                                                _createElementVNode("span", null, [
                                                  _hoisted_66,
                                                  _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                                                ]),
                                                ((record.pessoaRepasse > 0 && record.status === _ctx.EStatusTituloFinanceiro.Pendente || record.status === _ctx.EStatusTituloFinanceiro.BaixadoParcialmente))
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                                                      _createVNode(_component_a_tag, {
                                                        title: "Repassado",
                                                        class: "ss-tag-status titulo-baixado"
                                                      }),
                                                      _createTextVNode("Repassado")
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_68, [
                                                      _createVNode(_component_a_tag, {
                                                        title: text,
                                                        class: _normalizeClass('ss-tag-status titulo-' + _ctx.obterClasseStatus(text))
                                                      }, null, 8, ["title", "class"]),
                                                      _createTextVNode(_toDisplayString(record.descricaoStatus), 1)
                                                    ])),
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createElementVNode("a", {
                                                    class: "visualizar",
                                                    onClick: ($event: any) => (_ctx.editar(record.codigo))
                                                  }, [
                                                    _createVNode(_component_icone, { nome: "visualizar" })
                                                  ], 8, _hoisted_70),
                                                  _createElementVNode("a", {
                                                    onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                                                    class: "excluir"
                                                  }, [
                                                    _createVNode(_component_icone, { nome: "excluir" })
                                                  ], 8, _hoisted_71)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                    ]),
                    emptyText: _withCtx(() => [
                      _createVNode(_component_mensagem_sem_dados, {
                        resultadoPesquisa: !_ctx.telaBase.carregando,
                        mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                      }, null, 8, ["resultadoPesquisa", "mensagem"])
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("span", null, "Valor Total: R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.totalizadorSaldo, 2)), 1),
                      _createVNode(_component_a_pagination, {
                        class: "ss-paginacao-completa",
                        current: _ctx.state.paginacao.current,
                        "onUpdate:current": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                        size: "small",
                        total: _ctx.state.paginacaoApi.totalRegistros,
                        "show-total": _ctx.mostrarTotalPaginacao,
                        "page-size": _ctx.state.paginacao.pageSize,
                        pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                        onShowSizeChange: _ctx.mostrarNovaPagina,
                        onChange: _ctx.mudarPagina
                      }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "onChange"])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("span", _hoisted_75, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
                          onKeyup: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.keyupQuantidadeRegistroTotal && _ctx.keyupQuantidadeRegistroTotal(...args))),
                          placeholder: "Total registros",
                          type: "text",
                          class: "ant-input hidden"
                        }, null, 544), [
                          [_vModelText, _ctx.state.totalRegistrosComMascara],
                          [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                        ]),
                        _createElementVNode("span", _hoisted_76, [
                          _createVNode(_component_a_tooltip, { placement: "top" }, {
                            title: _withCtx(() => [
                              _hoisted_77
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_78, [
                                _createVNode(_component_icone, { nome: "informacoes" })
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["style"]),
              (_ctx.storeSistema.state.layoutMobile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      (!_ctx.storeSistema.state.layoutMobile && (_ctx.gradeBase.codigosSelecionados.length > 0))
        ? (_openBlock(), _createBlock(_component_card, {
            key: 0,
            class: "ss-acoes-massa-selecionados",
            style: _normalizeStyle(_ctx.storeSistema.getters.menuCollapse() ? 'width: calc(100% - 60px);' : 'width: calc(100% - 210px);'),
            titulo: "Ações em massa"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.textoCodigosSelecionados()), 1),
              _createElementVNode("span", null, "    R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.totalSelecionado)), 1),
              _createElementVNode("div", _hoisted_80, [
                ((_ctx.verificarAutorizacao('AUT_BAIXAS_CONTAS_RECEBER') && _ctx.tituloFinanceiroBase.titulosBaixar.length > 0))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      title: "Baixar",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.baixarTitulos()))
                    }, [
                      _createVNode(_component_icone, { nome: "correto" }),
                      _createTextVNode("Baixar ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.telaBase.permissaoDados.imprimir)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      title: "Imprimir",
                      onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" }),
                      _createTextVNode(" Imprimir ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tituloFinanceiroBase.titulosAlterar.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      title: "Alterar",
                      onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.alterarTitulos()))
                    }, [
                      _createVNode(_component_icone, { nome: "editar" }),
                      _createTextVNode(" Alterar ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tituloFinanceiroBase.titulosAntecipar.length > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      title: "Antecipar",
                      onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.anteciparTitulos()))
                    }, [
                      _createVNode(_component_icone, { nome: "correto" }),
                      _createTextVNode("Antecipar ")
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_dropdown, null, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                            }, [
                              _createVNode(_component_icone, { nome: "word" }),
                              _hoisted_82
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                            }, [
                              _createVNode(_component_icone, { nome: "excel" }),
                              _hoisted_83
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, null, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                            }, [
                              _createVNode(_component_icone, { nome: "download-arquivo" }),
                              _hoisted_84
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    (_ctx.telaBase.permissaoDados.imprimir)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                        }, [
                          _createVNode(_component_icone, { nome: "exportar" }),
                          _hoisted_81
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                ((_ctx.telaBase.permissaoDados.excluir && _ctx.tituloFinanceiroBase.titulosExcluir.length > 0))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 4,
                      title: "Excluir",
                      onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.confirmarExclusaoEmMassa()))
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" }),
                      _createTextVNode("Excluir ")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosSelecionados > 0 || _ctx.state.qtdBoletosGeradosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 5,
                      title: "Gerar Boleto(s)",
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.confirmarGerarBoletos(true)))
                    }, [
                      _createElementVNode("div", _hoisted_85, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosSelecionados + _ctx.state.qtdBoletosGeradosSelecionados,
                          class: "ss-contador-gerar-boletos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "codigo-barras"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_86
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 6,
                      title: "Imprimir Boleto(s)",
                      onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.confirmarGerarBoletos(false)))
                    }, [
                      _createElementVNode("div", _hoisted_87, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosGeradosSelecionados + _ctx.state.qtdBoletosRegistradosSelecionados,
                          class: "ss-contador-imprimir-boletos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "imprimir"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_88
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 7,
                      title: "Gerar Remessa de Boletos",
                      onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.confirmarGerarRemessa && _ctx.confirmarGerarRemessa(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_89, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosGeradosSelecionados + _ctx.state.qtdBoletosRegistradosSelecionados,
                          class: "ss-contador-gerar-remessa"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "compactar"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_90
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosGeradosSelecionados > 0 || _ctx.state.qtdBoletosRegistradosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 8,
                      title: "Enviar boletos por e-mail",
                      onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.confirmarEnviarEmailBoletos()))
                    }, [
                      _createElementVNode("div", _hoisted_91, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosGeradosSelecionados + _ctx.state.qtdBoletosRegistradosSelecionados,
                          class: "ss-contador-enviar-cobranca"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "email"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_92
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 9,
                      title: "Negativar Títulos",
                      onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.confirmarNegativcao(true)))
                    }, [
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosSelecionados,
                          class: "ss-contador-enviar-cobranca"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "documento-martelo"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_94
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.qtdBoletosSelecionados > 0)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 10,
                      title: "Protestar Títulos",
                      onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.confirmarNegativcao(false)))
                    }, [
                      _createElementVNode("div", _hoisted_95, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdBoletosSelecionados,
                          class: "ss-contador-enviar-cobranca"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "documento-martelo"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_96
                    ]))
                  : _createCommentVNode("", true),
                ((_ctx.state.qtdGerarNfse > 0))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 11,
                      title: "Emitir NFS-e",
                      onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.apresentarEmissaoNFSe && _ctx.apresentarEmissaoNFSe(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_97, [
                        _createVNode(_component_a_badge, {
                          count: _ctx.state.qtdGerarNfse,
                          class: "ss-contador-enviar-cobranca"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ss-texto-acao-massa",
                              nome: "emitir-nfse"
                            })
                          ]),
                          _: 1
                        }, 8, ["count"])
                      ]),
                      _hoisted_98
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["style"]))
        : _createCommentVNode("", true),
      _createVNode(_component_conta_receber_modal, {
        operacao: _ctx.state.operacaoLancamento,
        visivel: _ctx.state.exibirLancamento,
        "onUpdate:visivel": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.state.exibirLancamento) = $event)),
        onConfirmacao: _cache[58] || (_cache[58] = ($event: any) => (_ctx.atualizarInformacoesTela()))
      }, null, 8, ["operacao", "visivel"])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf,
      onFechado: _ctx.confirmarEnviarEmailBoletos
    }, null, 8, ["arquivos", "onFechado"]),
    _createVNode(_component_importacao_registros_excel_modal, {
      visivel: _ctx.state.exibirImportacaoExcel,
      "onUpdate:visivel": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.state.exibirImportacaoExcel) = $event)),
      empresa: _ctx.state.empresaSelecionada,
      tipoTitulo: 2
    }, null, 8, ["visivel", "empresa"]),
    _createVNode(_component_emissao_n_f_se_titulo_financeiro_modal, {
      visivel: _ctx.state.exibirEmissaoNFSe,
      "onUpdate:visivel": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.state.exibirEmissaoNFSe) = $event)),
      empresa: _ctx.state.empresaSelecionada,
      titulos: _ctx.state.titulosNFSe,
      onConfirmacao: _ctx.imprimirNFSes
    }, null, 8, ["visivel", "empresa", "titulos", "onConfirmacao"]),
    _createVNode(_component_alteracao_financeiro_massa_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirAlteracao,
      "onUpdate:visivel": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.state.exibirAlteracao) = $event)),
      titulos: _ctx.tituloFinanceiroBase.titulosAlterar,
      "onUpdate:titulos": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.tituloFinanceiroBase.titulosAlterar) = $event)),
      empresa: _ctx.state.empresaSelecionada,
      tipo: _ctx.ETipoTituloFinanceiro.Receber,
      onConfirmacao: _cache[63] || (_cache[63] = ($event: any) => (_ctx.atualizarInformacoesTela()))
    }, null, 8, ["operacao", "visivel", "titulos", "empresa", "tipo"])
  ], 64))
}